<template>
    <div class="widget-card">
        <div v-if="$slots.header || title" class="widget-card-header d-flex align-items-center justify-content-between gap-3">
            <div :class="hasSubtitle ? 'align-items-start' : 'align-items-center'" class="d-flex gap-3">
                <slot name="header">
                    <component :is="icon" v-if="icon" class="widget-icon" />
                    <div class="d-flex flex-column grow">
                        <div class="d-flex align-items-center gap-1">
                            <span class="widget-card-header__title d-flex align-items-center gap-1"
                                >{{ title }}
                                <info-icon v-if="infoTooltip" :tooltip="infoTooltip" />
                            </span>
                            <counter-pill v-if="count != null" :count="count" :loading="loading" />
                        </div>
                        <slot name="header-subtitle" />
                    </div>
                </slot>
            </div>
            <slot v-if="$slots['header-end']" name="header-end" />
        </div>
        <div class="widget-card-body">
            <slot />
        </div>
    </div>
</template>

<script setup>
import CounterPill from './CounterPill.vue';
import InfoIcon from '@/Components/InfoIcon.vue';
import { computed, useSlots } from 'vue';

const hasSubtitle = computed(() => !!useSlots()['header-subtitle']);

defineProps({
    title: {
        type: String,
        required: false,
    },
    infoTooltip: {
        type: String,
        required: false,
    },
    icon: {
        type: Object,
        required: false,
    },
    count: {
        type: Number,
        required: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
});
</script>

<style scoped>
.widget-card {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.widget-card-header {
    flex-shrink: 0;
    padding: 1rem;
    border-bottom: 1px solid var(--c-secondary);
}

.widget-card-body {
    flex: 1;
    overflow-y: auto;
    padding: 1rem;
    min-height: 0;
    /* Important for Firefox */
}
</style>
